import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {
  @Input() page = 1;
  @Input() pageSize = 10;
  @Input() totalItems = 0;
  @Input() pageSizeOptions: number[] = [2, 3, 9, 12, 18];
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  ngOnChanges(): void {
    if (this.page < 1) {
      this.page = 1;
    }
  }

  get showPagination(): boolean {
    return this.totalItems > 0;
  }

  onPage(event: PageEvent): void {
    const nextPage = event.pageIndex + 1;
    if (nextPage !== this.page) {
      this.pageChange.emit(nextPage);
    }

    if (event.pageSize !== this.pageSize) {
      this.pageSizeChange.emit(event.pageSize);
    }
  }
}
